import { StudioShell } from '@/components/layout/studio-shell';
import { lazy } from 'react';
import { Navigate, type RouteObject } from 'react-router';

const ConceptsLayout = lazy(() => import('@/routes/concepts/concepts-layout'));
const ConceptsEmpty = lazy(() => import('@/routes/concepts/concepts-empty'));
const ConceptsDetail = lazy(() => import('@/routes/concepts/concepts-detail'));
const DagRoute = lazy(() => import('@/routes/dag/dag'));
const ReviewLayout = lazy(() => import('@/routes/review/review-layout'));
const ReviewEmpty = lazy(() => import('@/routes/review/review-empty'));
const ReviewDetail = lazy(() => import('@/routes/review/review-detail'));

// Two-pane shape:
//   /concepts → ConceptsLayout (tree left + Outlet right)
//   /review  → ReviewLayout    (queue left + Outlet right)
// Draft IDs are path-as-id (slashes inside) so /review uses a splat.
// /inbox redirects to /review for back-compat with bookmarks.
export const routes: RouteObject[] = [
  {
    element: <StudioShell />,
    children: [
      { index: true, element: <Navigate to="/review" replace /> },
      { path: 'inbox', element: <Navigate to="/review" replace /> },
      {
        path: 'concepts',
        element: <ConceptsLayout />,
        children: [
          { index: true, element: <ConceptsEmpty /> },
          { path: ':subject/:topic/:name', element: <ConceptsDetail /> },
        ],
      },
      { path: 'dag', element: <DagRoute /> },
      {
        path: 'review',
        element: <ReviewLayout />,
        children: [
          { index: true, element: <ReviewEmpty /> },
          { path: '*', element: <ReviewDetail /> },
        ],
      },
      { path: '*', element: <Navigate to="/review" replace /> },
    ],
  },
];
